import * as React from 'react'
import Helmet from 'react-helmet'

import * as banner from "./../assets/contact-banner.jpg"

import './contact-us.css'
import Map from 'react-js-google-maps';

declare global {
  interface Window { google: any; gmaps: any }
}

const setMarker = (map: any) => {
    const mapIndex = 'map1';
    const uluru = { lat: 38.576373, lng: -121.3252138 };
    const marker = new window.google.maps.Marker({
      position: uluru,
      map: window.gmaps[mapIndex].gmap
    });
    const infoWindow = new window.google.maps.InfoWindow({
        content: "<b>Under Juniper Inc.</b><div>9921 Horn Road</div>"
    });
    infoWindow.open(map, marker);
    window.google.maps.event.addListener(marker, 'click', function()  {
        const clickWindow = new window.google.maps.InfoWindow({
          content: "<b>Under Juniper Inc.</b><div>9921 Horn Road</div>"
        });
        clickWindow.open(map, marker);
    })
  };

export default class extends React.Component<{}> {
  constructor(context: any) {
    super(context)
  }
  
  public render() {
    const mapOptions = {
        zoom: 15,
        center: { lat: 38.5785201, lng: -121.3252138 }
      }

    return (
      <div>
        <Helmet
            bodyAttributes={{
                class: 'contact-body'
            }}
        />

        <div className="caption-container">
            <img width={980} height={273} alt="Fourth" src={banner} style={{margin: 0}}/>
            <h1 className="caption">NEED CONSULTATIONS & DESIGN IDEAS FOR YOUR PROJECTS?</h1>
        </div>

        <div style={{
            height: "auto",
            backgroundColor: "rgba(255, 255, 255, 0.75)",
            padding: "1px 25px 15px",
            marginBottom: "10px",
          }}>

          <p className="contact-para">
            Located in Sacramento (CA), Under Juniper, Inc. is a design-build company offering services in conceptual planning and design and construction management  to all residential and commercial customers in the Northern California. Should you have any questions, request Free-Estimate or require more information about your current project, do not hesitate to contact us - we will be able to answer all your questions with a level of professionalism unmatched by anyone in the landscape industry.
          </p>

          <hr style={{margin: 0, marginTop: '2px', borderColor: 'rgb(150, 150, 150)'}}/>

          <h2 className="contact-title">CONTACT <span style={{color: "#346B1F"}}>US</span></h2>

          <div className="contact-desc">
            <p style={{marginRight: "20px"}}>
                <span style={{color: "#207EA9"}}>Direct Phone:</span> 916-201-9821<br/>
                <span style={{color: "#207EA9"}}>Office:</span> 916-368-8898<br/>
                <span style={{color: "#207EA9"}}>Fax:</span> 916-368-8899<br/><br/>
                <span style={{color: "#207EA9"}}>Office Hours:</span> Monday - Saturday, 7 AM - 5:30 PM<br/>
                <span style={{color: "#207EA9"}}>E-mail:</span> info@underjuniper.com<br/><br/>
                <span style={{color: "#207EA9"}}>Address:</span><br/>
                9921 Horn Road<br/>
                Sacramento, CA 95827
            </p>
            <Map
                id="map1"
                apiKey="AIzaSyDVZdDu1JNKA0cX0FWwEXYATpI1Pv3jyx8"
                mapOptions={mapOptions}
                style={{ width: '423px', height: "203px", flexShrink: 1 }}
                onLoad={setMarker}
            />
          </div>
          
          <div className="form-class">
            <form method="POST" action="https://formcarry.com/s/Hy9lwAAnM">

              <fieldset>
                <input name="name" placeholder="Name" />
              </fieldset>

              <fieldset>
                <input name="email" placeholder="Email" />
              </fieldset>

              <fieldset>
                <input name="address" placeholder="Address" />
              </fieldset>

              <fieldset>
                <input name="subject" placeholder="Subject" />
              </fieldset>

              <fieldset>
                <textarea name="message" placeholder="Message" />
              </fieldset>

              <button>
                <i/>&nbsp;Send
              </button>

            </form>
          </div>

          <hr style={{margin: 0, marginTop: '2px', borderColor: 'rgb(150, 150, 150)'}}/>

          <p className="contact-para">
            Whether you are building a new home, office, large-scale resort complex or just wanting to renovate your existing facilities; Under Juniper is ready to help you achieve the look you want for your property. We will work with you to create a design that complements the specific characteristics of your home, place of business, or any associated property.<br/><br/>
            All construction and development projects require a preliminary consultation with the customer. We will provide you with a complete quotation for your review and approval prior to commencing work.
          </p>

        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/contact-us.tsx